var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2CA01C",
    stroke: "#2CA01C",
    strokeWidth: 0.5,
    d: "M9,3h6V1.25c0-0.066-0.025-0.13-0.072-0.177 C14.88,1.026,14.816,1,14.75,1h-5.5C9.184,1,9.12,1.026,9.073,1.073C9.026,1.12,9,1.184,9,1.25V3z M20,4H4v18c0,0.553,0.448,1,1,1 h14c0.553,0,1-0.447,1-1V4z M10,7.5C10,7.224,9.776,7,9.5,7S9,7.224,9,7.5v12C9,19.775,9.224,20,9.5,20s0.5-0.225,0.5-0.5V7.5z  M15,7.5C15,7.224,14.775,7,14.5,7S14,7.224,14,7.5v12c0,0.275,0.225,0.5,0.5,0.5s0.5-0.225,0.5-0.5V7.5z M23,3v1h-2v18 c0,1.105-0.895,2-2,2H5c-1.105,0-2-0.895-2-2V4H1V3h7V1c0-0.552,0.448-1,1-1h6c0.553,0,1,0.448,1,1v2H23z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.cbf7e1b4.svg";
export { ForwardRef as ReactComponent };